<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Parámetros de Inflación">
          <b-form>
            <b-form-group
              label="Período"
              label-for="periodo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="periodo"
                v-model.trim="$v.periodo.$model"
                :state="periodoValido"
                type="date"
                :disabled="id != 0"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="periodoFeedback">
                {{ periodoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Pje.Inflación"
              label-for="pjeInflacion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="pjeInflacion"
                v-model.trim="$v.pjeInflacion.$model"
                :state="pjeInflacionValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="pjeInflacionFeedback">
                {{ pjeInflacionInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import ABMButtons from '../shared/abmButtons.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { decimal, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'parametroinflacion/getField',
  mutationType: 'parametroinflacion/updateField',
});

export default {
  name: 'ABM',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      periodoValido: null,
      periodoInvalidoMsj: '',
      pjeInflacionValido: null,
      pjeInflacionInvalidoMsj: '',

      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'id',
      'periodo',
      'pjeInflacion',
    ])
  },
  created() {
    let parametroId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        parametroId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('parametroinflacion/inicializar', parametroId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'pjeInflacion' || validarTodos) {
        if (this.$v.pjeInflacionMinimo.$error) {
          this.pjeInflacionValido = false;

          if (!this.$v.pjeInflacion.decimal) {
            this.pjeInflacionInvalidoMsj = 'El porcentaje debe ser un valor numérico';
          // } else if (!this.$v.pjeInflacion.minValue) {
          //   this.pjeInflacionInvalidoMsj = 'El porcentaje debe ser un valor numérico positivo';
          }
        } else {
          this.pjeInflacionValido = null;
          this.pjeInflacionInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.showSpinner();
        this.$store.dispatch('parametroinflacion/save')
          .then(() => this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    goList() {
      this.$router.push({ name: "ParametrosInflacion" });
    },
  },
  validations: {
    periodo: {},
    pjeInflacion: {
      decimal,
      // minValue: minValue(0),
    },
  },  
}
</script>
